<template>
	<el-row id="category" class="container">
		<el-col :span="22" :offset="1">
			<div class="category-legend" v-text="content.name"></div>
			<div v-if="orphan" class="border left"></div>
			<div v-if="orphan" class="border right"></div>
			<template v-if="content.children">	
				<el-tabs type="card" @tab-click="handleClick">
					<div class="tabs-container">
						<template v-for="category in content.children">
							<el-tab-pane :label="category.name">
								<template v-if="category.children">
									<template v-for="subcategory in category.children">
										<el-row>
											<div class="legend" v-text="subcategory.name"></div>
											<template v-for="product in subcategory.products">
												<el-col :span="8" class="product">
													<div class="inner">
														<div v-text="product.title"></div>
														<router-link :to="{ name: 'subcategory', params: { category: slug, subcategory: category.slug, subsubcategory: subcategory.slug, product: product.slug } }" class="link"></router-link>
													</div>
												</el-col>
											</template>
										</el-row>
									</template>
								</template>
								<template v-else>
									<template v-for="product in category.products">
										<el-col :span="8" class="product">
											<div class="inner">
												<div v-text="product.title"></div>
												<router-link :to="{ name: 'subcategory', params: { category: slug, subcategory: category.slug, product: product.slug } }" class="link"></router-link>
											</div>
										</el-col>
									</template>
								</template>							
							</el-tab-pane>
						</template>
					</div>
				</el-tabs>
			</template>
			<template v-else>
				<div>
					<template v-for="product in content.products">
						<el-col :span="8" class="product">
							<div class="inner">
								<div v-text="product.title"></div>
								<router-link :to="{ name: 'product', params: { category: slug, product: product.slug } }" class="link"></router-link>
							</div>
						</el-col>
					</template>
				</div>
			</template>
		</el-col>
	</el-row>
</template>

<script>

	export default {
		data() {
			return{
				slug: this.$route.params.category
			}
		},
		computed : {
			content () {
				return this.$store.getters.content[this.slug]
			},
			orphan () {
				return ( this.content.products ) ? false : true
			}
		},
		methods : {
			handleClick (tab, event) {
				this.$store.commit('LAST_CATEGORY_VIEW', tab );	
			}
		},
		created() {
			this.$store.commit('ON_CATEGORY_VIEW');
		}
	}
</script>

<style lang="less">

	#category{
		position: relative;
		height: ~"calc(100% - 215px)";
		overflow: hidden;

		.el-col-22{
			position: relative;
			height: 100%;

			.border{
				position: absolute;
				height: 1px;
				width: 50%;
				top: 85px;
				background: rgb(229, 210, 209);

				&.left{
					left: -50%;
				}

				&.right{
					right: -50%;
				}
			}

			.el-tabs{
				height: ~"calc(100% - 125px)";
			}
		}



		.el-tabs__header{
			margin-bottom: 15px;
		}

		.el-tabs__content{
			height: 100%;
			margin-left: -15px;
			margin-right: -15px;
		}

		.tabs-container{
			height: 100%;
			overflow-y: scroll;
			-webkit-overflow-scrolling: touch;
			padding-left: 10px;
			padding-right: 10px;
		}

		.el-card__body{
			position: relative;
			padding: 15px;
			overflow: hidden;
		}
		.el-tabs--card>.el-tabs__header .el-tabs__item.is-active{
			border-bottom-color: #F2F2F2;
		}
		.el-tabs__item{
			text-transform: uppercase;
		}

		.category-legend{
			text-transform: uppercase;
			font-weight: bold;
			margin-top: 10px;
			margin-bottom: 15px;
		}
		
		.legend{
			text-align: left;
			margin-left: 5px;
			text-transform: uppercase;
			font-weight: bold;
			margin-top: 10px;
		}
	}

	.product{
		padding: 5px;

		.inner{
			position: relative;
			width: 100%;
			height: 175px;
			background-color: #E82537;	
			display: table;

			div{
				display: table-cell;
				vertical-align: middle;
				color: white;
				font-size: 20px;
				padding: 0 10px;
			}

		}

		.link{
			position: absolute;
			width: 100%;
			height: 100%;
			top: 0;
			right: 0;
			bottom: 0;
			left: 0;	
		}
	}
</style>




// WEBPACK FOOTER //
// Category.vue?529fe910